<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.surveys', 2),
                        href: meta.links.index,
                    },
                    {
                        name: survey.title,
                        href: null,
                    },
                    {
                        name: report.date_display,
                        href: null,
                    },
                ]"
            />
        </template>
        <div>
            <SurveyReport :survey="survey" :report="report" />
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SurveyReport from '../../Teacher/Surveys/GroupReports/partials/SurveyReport.vue';

export default {
    components: {
        SurveyReport,
        PanelPage,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'survey', 'report'],
};
</script>
